// Janela de "data de entrada" do Kanban/Leads.
//
// O preset ('month', 'today', '7', '30', '90') é resolvido AQUI, a cada render,
// e nunca gravado na URL. Gravar a data resolvida foi o bug original: "Este mês"
// virava "do dia 1º até o dia em que cliquei", e lead novo sumia do quadro.
//
// Preset não tem limite superior de propósito: "últimos 7 dias" é uma janela que
// termina no presente, então o teto é sempre "agora".

/** Data no formato YYYY-MM-DD no fuso LOCAL — `toISOString()` usa UTC e adianta o dia à noite. */
export const formatLocalDate = (date: Date): string => {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export interface CreatedRange {
  created_from?: string;
  created_to?: string;
}

/**
 * Resolve a janela efetiva. Com preset, `from` é recalculado a partir de `now` e
 * `to` fica aberto. Sem preset, devolve as datas cruas (período personalizado).
 */
export const resolveCreatedRange = (
  preset: string | null | undefined,
  from: string | null | undefined,
  to: string | null | undefined,
  now: Date = new Date(),
): CreatedRange => {
  if (!preset) {
    return { ...(from ? { created_from: from } : {}), ...(to ? { created_to: to } : {}) };
  }

  if (preset === 'month') {
    return { created_from: formatLocalDate(new Date(now.getFullYear(), now.getMonth(), 1)) };
  }
  if (preset === 'today') {
    return { created_from: formatLocalDate(now) };
  }

  const days = Number(preset);
  if (!Number.isFinite(days) || days <= 0) return {};

  const start = new Date(now);
  start.setDate(start.getDate() - days);
  return { created_from: formatLocalDate(start) };
};
